import { useState } from "react";




interface ProjectImageProps {
  src?: string | null;
  alt: string;
  className?: string;
  /** Extra classes for the "photo coming soon" placeholder wrapper */
  placeholderClassName?: string;
  loading?: "lazy" | "eager";
  decoding?: "async" | "sync" | "auto";
  /** Called when no photo exists (empty src), instead of showing the placeholder */
  onMissing?: () => void;
  width?: number;
  height?: number;
  srcSet?: string;
  sizes?: string;
  /** Homepage service cards omit missing photography rather than advertising a placeholder. */
  hidePlaceholder?: boolean;
}

/**
 * Renders a project photo, falling back to a visible "Photo coming soon"
 * placeholder when the image has no source or fails to load — so a missing
 * photo never renders as an empty box.
 */
const ProjectImage = ({
  src,
  alt,
  className,
  placeholderClassName,
  loading = "lazy",
  decoding = "async",
  onMissing,
  width,
  height,
  srcSet,
  sizes,
  hidePlaceholder = false,
}: ProjectImageProps) => {
  const [failed, setFailed] = useState(false);

  if (!src || failed) {
    if (onMissing) queueMicrotask(onMissing);
    return null;
  }

  return (
    <img
      src={src}
      srcSet={srcSet}
      sizes={sizes}
      width={width}
      height={height}
      alt={alt}
      loading={loading}
      decoding={decoding}
      className={className}
      onError={() => setFailed(true)}
    />
  );
};

export default ProjectImage;
